// React
import React from 'react';
import Select from 'react-select';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap';

// Injection
import { Section, PageWrapper } from '../../containers/componentsInjection';

export const CategoriesFinanceFormPage = ({
  id,
  type,
  history,
  validation,
  categoryFinanceSelect,
}) => {
  return (
    <PageWrapper title={'Categorias'}>
      <Row>
        <Col>
          <Card>
            <div className="live-preview">
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <CardBody>
                  <Section id={id} />
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Tipo
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          disabled
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={type === 'D' ? 'Despesas' : 'Receitas'}
                        />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Nome da Categoria
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="subCategoryOf" className="form-label">
                          Subcategoria de
                        </Label>
                        <Select
                          isClearable={true}
                          value={
                            validation.values.subCategoryOf || {
                              value: '',
                              label: 'Selecione uma categoria',
                            }
                          }
                          onChange={(e) => {
                            const event = {
                              target: {
                                name: 'subCategoryOf',
                                value: e,
                              },
                            };
                            validation.handleChange(event);
                          }}
                          onBlur={validation.handleBlur}
                          options={categoryFinanceSelect || []}
                          inputId="subCategoryOf"
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Col md={12}>
                    <div className="text-end d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link"
                        style={{
                          marginRight: '10px',
                        }}
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Salvar
                      </button>
                    </div>
                  </Col>
                </CardFooter>
              </Form>
            </div>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
